import { toast } from '@zerodevx/svelte-toast'

export const  error  = m => toast.push(m, {
  theme: {
    "--toastBackground": "#F56565",
    "--toastBarBackground": "#C53030",
  }
})
export const success  = m => toast.push(m, {
  theme: {
    "--toastBackground": "#48BB78",
    "--toastBarBackground": "#2F855A",
  }
})